import React, { useMemo } from 'react'
import { Route, Redirect } from '@fs/zion-router'
import { useFeatureFlag } from '@fs/zion-flags'
import { useUser } from '@fs/zion-user'
import useUserStats from '../../hooks/useUserStats'

const HintsRoute = ({ children, ...rest }) => {
  const { isOn } = useFeatureFlag('give_recordHints')
  const { signedIn, userLoading } = useUser()
  const { data, loading } = useUserStats()

  const isAuthorized = useMemo(() => {
    if (!signedIn && !userLoading && !loading) {
      return false
    }
    const allTimeActivities = data?.stats?.allTime?.activities
    const isIndexingReviewer =
      allTimeActivities?.['IndexIDXRecords-INDEXING.ARBITRATE'] > 0 ||
      allTimeActivities?.['IndexIDXRecords-INDEXING.REVIEW'] > 0 ||
      allTimeActivities?.['IndexIDXRecords-INDEXING.ANALYZE'] > 0 ||
      allTimeActivities?.['CuratePublicTree-Record Hint'] > 0

    return isOn && !!isIndexingReviewer
  }, [isOn, signedIn, userLoading, data, loading])

  if (loading || userLoading) {
    return null
  }

  return (
    <Route
      {...rest}
      render={(routeProps) => (isAuthorized ? children(routeProps) : <Redirect to="/opportunities" />)}
    />
  )
}

export default HintsRoute
